import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActionComponent } from '@ntap/core';

@Component({
  selector: 'app-spremiste2-dgrafika-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./spremiste2-dgrafika-action.component.scss']
})
export class Spremiste2DGrafikaActionComponent extends ActionComponent {
  private router = inject(Router);

  override execute() {
    this.router.navigate(['/spremiste2d']);
  }
}
